import { isMobile, isTablet } from "react-device-detect"

export const isSmartphone = isMobile && !isTablet

export function SmartphoneView({ children }) {
	if (isMobile && !isTablet) {
		return <>{children}</>
	}
	return null
}

export default SmartphoneView
